import React from "react";
import { observer } from "mobx-react";
import { SnapshotOverrideUpdateStore } from "../../store";
import { SnapshotOverrideUpdateForm } from "./SnapshotOverrideUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type SnapshotOverrideUpdateProps = {
  snapshotOverrideUpdateStore: SnapshotOverrideUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const SnapshotOverrideUpdate: React.FC<SnapshotOverrideUpdateProps> =
  observer(
    ({ snapshotOverrideUpdateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={snapshotOverrideUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={snapshotOverrideUpdateStore.savedButOutdated}
            onReload={() =>
              snapshotOverrideUpdateStore.reloadSnapshotOverride()
            }
            reloadDisabled={snapshotOverrideUpdateStore.isProcessing}
          />
          <SnapshotOverrideUpdateForm
            snapshotOverrideUpdateStore={snapshotOverrideUpdateStore}
            relatedEntityTypeError={
              snapshotOverrideUpdateStore.errors.relatedEntityType?.message
            }
            onRelatedEntityTypeChange={(value: string) => {
              snapshotOverrideUpdateStore.setRelatedEntityTypeValue(value);
            }}
            relatedEntityType={
              snapshotOverrideUpdateStore.entityValues.relatedEntityType
            }
            relatedEntityIdError={
              snapshotOverrideUpdateStore.errors.relatedEntityId?.message
            }
            onRelatedEntityIdChange={(value: string) => {
              snapshotOverrideUpdateStore.setRelatedEntityIdValue(value);
            }}
            relatedEntityId={
              snapshotOverrideUpdateStore.entityValues.relatedEntityId
            }
            pathError={snapshotOverrideUpdateStore.errors.path?.message}
            onPathChange={(value: string) => {
              snapshotOverrideUpdateStore.setPathValue(value);
            }}
            path={snapshotOverrideUpdateStore.entityValues.path}
            valueError={snapshotOverrideUpdateStore.errors.value?.message}
            onValueChange={(value: string) => {
              snapshotOverrideUpdateStore.setValueValue(value);
            }}
            value={snapshotOverrideUpdateStore.entityValues.value}
            noteError={snapshotOverrideUpdateStore.errors.note?.message}
            onNoteChange={(value: string) => {
              snapshotOverrideUpdateStore.setNoteValue(value);
            }}
            note={snapshotOverrideUpdateStore.entityValues.note}
            activeError={snapshotOverrideUpdateStore.errors.active?.message}
            onActiveChange={(value: boolean) => {
              snapshotOverrideUpdateStore.setActiveValue(value);
            }}
            active={snapshotOverrideUpdateStore.entityValues.active}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={snapshotOverrideUpdateStore.saveDisabled}
            onSave={() => snapshotOverrideUpdateStore.saveSnapshotOverride()}
            onCancel={() =>
              snapshotOverrideUpdateStore.cancelSnapshotOverride()
            }
          />
          <ErrorDialog
            open={snapshotOverrideUpdateStore.errorDialogOpened}
            title={snapshotOverrideUpdateStore.errorTitle}
            description={snapshotOverrideUpdateStore.errorDescription}
            onClose={() => snapshotOverrideUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={snapshotOverrideUpdateStore.confirmDialogOpened}
            title={snapshotOverrideUpdateStore.confirmDialogTitle}
            description={snapshotOverrideUpdateStore.confirmDialogDescription}
            onConfirm={() =>
              snapshotOverrideUpdateStore.executeConfirmedAction()
            }
            onCancel={() => snapshotOverrideUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
